import { addLearningJournal, deleteLearningJournal, updateLearningJournal } from './learningJournalActions'
import { Constants } from './learningJournalConstants'
import { learningJournal } from '../../../model/learnJournal.model'


type Actions =
	| ReturnType<typeof addLearningJournal>
	| ReturnType<typeof updateLearningJournal>
	| ReturnType<typeof deleteLearningJournal>

export function learningJournalReducer(
	state: learningJournal[] = [],
	action: Actions
): learningJournal[] {
    switch (action.type) {
		case Constants.ADD_LEARNING_JOURNAL:

			// we don't do anything if we accidentally create on that already exists
			if (state.find(val => action.payload.learning_journal_id === val.learning_journal_id)){
				return [...state]
			}

			
			return [...state, action.payload]

		case Constants.UPDATE_LEARNING_JOURNAL:
			const payloadCopy = {...action.payload}
			return state.map((entry) => {
				if (entry.learning_journal_id !== payloadCopy.learning_journal_id){
					return entry
				}
				return {
					...entry,
					...payloadCopy
				}
			})
		
		default:
			return state

		case Constants.DELETE_LEARNING_JOURNAL:
			return state.filter(j => action.payload.learning_journal_id !== j.learning_journal_id)
	}
}